import React, { Component } from "react";
import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";
import toastr from "toastr";
import { Link } from "react-router-dom";
import { ProjectService } from "app/_services/ProjectService/ProjectService";
import {
  Dropdown,
  Row,
  Col,
  Tab,
  Tabs,
  Button,
  TabContent,
  Nav,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FiPlusCircle, FiMinusCircle, FiCopy } from "react-icons/fi";
import { FiCamera } from "react-icons/fi";
import DateTime from "react-datetime";
import { FaUserAlt } from "react-icons/fa";
import { FiEye } from "react-icons/fi";
import { SignUpServices } from "app/_services/Auth/SingnUpServices";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      error: {},
      projectId: this.props.match.params.id ? this.props.match.params.id : "",
      projectData: {},
      oldPassword: "",
      password: "",
      Confirm_password: "",
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {}

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  async onSubmit() {
    if (this.state.password.length < 6) {
      toastr.warning("Password must be 6 character long");
    } else if (this.state.Confirm_password === this.state.password) {
      let data = {
        oldPassword: this.state.oldPassword,
        password: this.state.password,
      };
      let response = await SignUpServices.changePassword(data);
      if (response && response.message && response.status === 0) {
        toastr.warning(response.message);
      } else if (response) {
        toastr.info("Password Changed Successful!");
        this.props.history.push("/");
      }
    } else {
      toastr.warning("Password do not Match");
    }
  }

  render() {
    console.log("this", this.state);
    return (
      <div>
        {/* <Breadcrumb
                    routeSegments={[
                        // { name: this.state.projectData.name, path: "/project/" + this.state.projectId + "/dashboard" },
                        { name: "Change Password", path: "#" },
                    ]}
                /> */}
        <MainBreadcrumb
          routeSegments={[{ name: "Change Password", path: "#" }]}
          breadCrumbsText="Profile_icon_change_password"
        />
        <div className="row d-flex justify-content-center">
          <div className="col-md-5">
            <div className="card mt-12 mb-3" style={{ overflow: "visible" }}>
              <div className="card-body">
                <div className="simple-card-title">
                  <h3 class="text-capitalize mb-1">Change Password</h3>
                </div>
                <div className="row">
                  <div className="col-md-12 form-group mb-3">
                    <label>Old Password</label>
                    <input
                      type="password"
                      placeholder="Old Password"
                      className="form-control"
                      onChange={this.onChange}
                      value={this.state.oldPassword}
                      name="oldPassword"
                    />
                  </div>
                  <div className="col-md-12 form-group mb-3">
                    <label>New Password</label>
                    <input
                      type="password"
                      placeholder="New Password"
                      className="form-control"
                      onChange={this.onChange}
                      value={this.state.password}
                      name="password"
                    />
                  </div>
                  <div className="col-md-12 form-group mb-3">
                    <label>Confirm New Password</label>
                    <input
                      type="password"
                      placeholder="Confirm New Password"
                      className="form-control"
                      onChange={this.onChange}
                      value={this.state.Confirm_password}
                      name="Confirm_password"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    {/* <Link to={"/project/" + this.state.projectId + "/laq-civil/civil-work-status"} className="btn btn-secondary mr-2">Back</Link> */}
                    <button
                      className="btn btn-primary ml-2"
                      onClick={() => this.onSubmit()}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ChangePassword;
